// Diegetic UI elements: stamina bracelet around the wrist (third-person),
// a stamina ring on the seeker's flashlight base (first-person), and a
// "round status board" mounted on each hut.
//
// No screen overlays — everything sits in 3D.

import * as THREE from 'three';
import { makeToonMaterial, addOutline } from './flat.js';

// Stamina ring — a torus that fills/depletes by scaling its arc.
// We hack arc rendering by using ThetaLength on TorusGeometry and rebuilding
// when stamina changes (cheap; rebuild only every 0.05 stamina change).
export class StaminaRing {
  constructor({ color = 0xffd285, radius = 0.18, tube = 0.03 } = {}) {
    this.color = color;
    this.radius = radius;
    this.tube = tube;
    this.value = 1;
    this.group = new THREE.Group();
    this.mat = makeToonMaterial({ color, bands: 2, rim: 0.4, emissive: color, emissiveIntensity: 0.5 });
    this.mesh = null;
    this._rebuild(1);
  }
  _rebuild(v) {
    if (this.mesh) {
      this.group.remove(this.mesh);
      this.mesh.geometry.dispose();
    }
    const arc = Math.max(0.05, v) * Math.PI * 2;
    const geo = new THREE.TorusGeometry(this.radius, this.tube, 6, 24, arc);
    this.mesh = new THREE.Mesh(geo, this.mat);
    this.group.add(this.mesh);
  }
  set(v) {
    if (Math.abs(v - this.value) > 0.04) {
      this.value = v;
      this._rebuild(v);
    }
  }
}

// Status board: a wooden plank with painted lozenges showing rounds won.
export function makeStatusBoard({ rounds = 5 } = {}) {
  const grp = new THREE.Group();
  const plank = new THREE.Mesh(
    new THREE.BoxGeometry(2.4, 0.6, 0.08),
    makeToonMaterial({ color: 0x6a4a30, bands: 3, rim: 0.4 })
  );
  addOutline(plank, 0.02);
  grp.add(plank);
  const dots = [];
  for (let i = 0; i < rounds; i++) {
    const d = new THREE.Mesh(
      new THREE.CircleGeometry(0.12, 16),
      makeToonMaterial({ color: 0x222633, bands: 2, rim: 0.3 })
    );
    d.position.set(-0.9 + i * 0.45, 0, 0.05);
    grp.add(d);
    dots.push(d);
  }
  grp.userData.setProgress = (won) => {
    dots.forEach((d, i) => {
      d.material.color.setHex(i < won ? 0xffd285 : 0x222633);
    });
  };
  return grp;
}
